import { CommonModule } from '@angular/common';
import { KeycloakComponent } from './components/keycloak/keycloak.component';
import { NgModule } from '@angular/core';
import { OAuthModule } from 'angular-oauth2-oidc';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { routes } from './auth-routing';
import { NafathLoginComponent } from './components/nafath-login/nafath-login.component';

@NgModule({
  declarations: [
    KeycloakComponent,
    NafathLoginComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    OAuthModule.forRoot(),
    RouterModule.forChild(routes)
  ],
  providers: []
})
export class AuthModule { }
